import { useGetData, useToggleStatusMutation } from "@/services";
import { MasterModuleLayout, useMasterModule } from "../Common";

const IncidentCategory = () => {
  const masterHook = useMasterModule({
    queryKey: "incident-categories",
    idKey: "categoryId",
    nameKey: "categoryName",
    useGetDataQuery: useGetData,
    useToggleStatusMutation: useToggleStatusMutation,
    module: "incident-categories",
    statusSuccessMessage: "Incident Category Status Updated Successfully",
  });

  return <MasterModuleLayout title="Incident Categories" hookResult={masterHook} />;
};

export default IncidentCategory;
